import React from "react";
import salesforceLogo from "../../../../assets/integrations/salesforce-logo.png";

const IntegrationInfo = () => {
  return (
    <div className="salesforce-info-section">
      <div className="salesforce-info-header">
        <div className="salesforce-title-group">
          <div className="salesforce-logo-wrapper">
            <img src={salesforceLogo} alt="Salesforce" className="salesforce-logo" />
          </div>
          <h1 className="salesforce-title">Salesforce</h1>
        </div>
        <div className="salesforce-info-content">
          <p className="salesforce-description">
            A unified CRM platform for marketing, sales, and CS.
          </p>
        </div>
      </div>
      <div className="salesforce-info-actions">

      </div>
    </div>
  );
};

export default IntegrationInfo;
